import { Node } from 'reactflow';

// React Flow hides a node until it has both a width and a height, and only re-measures
// when its resize observer fires. Replacing a node without them can leave it hidden for good.
export const keepMeasuredSize = <T extends Node>(nextNodes: T[], currentNodes: Node[]): T[] => {
  const measured = new Map(currentNodes.map((node) => [node.id, node]));

  return nextNodes.map((node) => {
    const current = measured.get(node.id);
    if (!current?.width || !current?.height) {
      return node;
    }

    return { ...node, width: current.width, height: current.height };
  });
};
